<template>
  <v-row no-gutters>
    <v-col cols="auto" class="pr-1">
      <base-button
        class="mobile-map-button-shadow"
        text="buttons.clearFilters"
        text-icon="mdi-cancel"
        small
        @click="clearFilter"
      />
    </v-col>
    <v-col cols="auto" class="text-center">
      <v-badge overlap :content="filterPayloadLength" :value="filterPayloadLength || false" color="error">
        <base-button
          text-icon="mdi-tune"
          color="third"
          small
          height="28"
          width="34"
          class="mobile-filter-button mobile-map-button-shadow"
          @click="isFilterVisible = true"
        />
      </v-badge>
    </v-col>
  </v-row>
</template>
<script>
import { sync } from 'vuex-pathify';

import BaseButton from '@/components/shared/buttons/BaseButton';

export default {
  name: 'TheMobileMapButtons',
  components: { BaseButton },
  computed: {
    isFilterVisible: sync('tools/isFilterVisible'),
    filterPayload: sync('map/filterPayload'),
    filterPayloadLength() {
      return (
        Object.values(this.filterPayload)?.filter(v => (!!v || v === 0 || v === false) && v?.length !== 0).length || 0
      );
    },
  },
  methods: {
    clearFilter() {
      this.filterPayload = {};
    },
  },
};
</script>
<style lang="scss" scoped>
.mobile-filter-button {
  min-width: unset !important;
}
</style>
